<template>
  <div class="pages-pagination-container">
    <div class="row pages-pagination-wrapper">
      <div class="col-4">
        <button
          ref="prev"
          v-if="isEnabledPreviousPage"
          class="pages-pagination--previous"
          @click="handelPreviousPageClick"
        >
            <img src="@/assets/images/ic_arrow_left_black.svg" alt="icon" />
            <span>{{ $t('viewer.sam.quiz.prev.button') }}</span>
        </button>
      </div>

      <div class="pages-pagination--pager col-4">
        <strong>{{ pagination.page }}</strong> / {{ pagination.totalPages }}
      </div>

      <div class="col-4">
        <button
          ref="next"
          v-if="isDiabledNextButton"
          class="pages-pagination--pending"
          disabled
        >
          <span>{{ $t('viewer.page.result.button') }}</span>
          <img src="@/assets/images/ic_arrow_right_gray.svg" alt="icon" />
        </button>

        <button
          ref="next"
          v-if="isEnabledSubmitButton"
          class="pages-pagination--next"
          @click="handleCatQuizSubmit"
          :disabled="isLoadingSubmit"
        >
          <template v-if="!isLoadingSubmit">
            <span>{{ $t('viewer.page.result.button') }}</span>
            <img src="@/assets/images/ic_arrow_right_purple.svg" alt="icon" />
          </template>
          <LoadingBounce v-else colorType="secondary" />
        </button>

        <button
          ref="next"
          v-if="isEnabledNextButton"
          class="pages-pagination--next"
          @click="handleNextPageClick"
        >
          <span>{{ $t('viewer.sam.quiz.next.button') }}</span>
          <img src="@/assets/images/ic_arrow_right_purple.svg" alt="icon" />
        </button>

        <button
          ref="next"
          v-if="isQuizResultButton && !isBookmarkedQuizMode"
          class="pages-pagination--next"
          @click="handleLastPageClick"
        >
          <span>{{ $t('viewer.page.submit.button') }}</span>
          <img src="@/assets/images/ic_arrow_right_purple.svg" alt="icon" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isNil } from 'lodash';

import CatQuizSubmit from './mixins/CatQuizSubmit';

export default {
  name: 'cat-pages-pagination',

  mixins: [
    CatQuizSubmit,
  ],

  props: [
    'pagination',
    'routeName',
  ],

  data() {
    return {
      quizSubmitLimitTime: 3,
    };
  },

  computed: {
    ...mapGetters({
      catPagesId: 'getCatPagesId',
      routeParams: 'getRouteParams',
      quizSolved: 'getCatQuizSolved',
      selectedOption: 'getSelectedOption',
      selectedOptionId: 'getSelectedOptionId',
      catPage: 'getCatPage',
      catQuizStartTime: 'getCatQuizStartTime',
      catQuizResult: 'getCatQuizResult',
      isTeachingMode: 'isTeachingMode',
      routeQuery: 'getRouteQuery',
      isBookmarkedQuizMode: 'isBookmarkedQuizMode',
    }),

    previousPageParams() {
      return { page: this.pagination.page - 1 };
    },

    isEnabledPreviousPage() {
      return this.pagination.page > 1;
    },

    isEnabledNextPage() {
      return this.pagination.page < this.pagination.totalPages;
    },

    isEnabledQuizResult() {
      return this.pagination.page === this.pagination.totalPages;
    },

    isOptionNotSelected() {
      return isNil(this.selectedOptionId) && isEmpty(this.selectedOption);
    },

    isDiabledNextButton() {
      return this.isOptionNotSelected && !this.quizSolved;
    },

    isEnabledNextButton() {
      return this.isEnabledNextPage && this.quizSolved;
    },

    isEnabledSubmitButton() {
      return !this.isOptionNotSelected
          && !this.quizSolved
          && this.catPage.is_quiz;
    },

    isQuizResultButton() {
      return this.isEnabledQuizResult && this.quizSolved && !this.isTeachingMode;
    },
  },

  methods: {
    handelPreviousPageClick() {
      return this.$router.push({
        name: this.routeName,
        params: this.previousPageParams,
        query: this.routeQuery,
      });
    },

    handleNextPageClick() {
      return this.$router.push({
        name: this.routeName,
        params: {
          catId: this.routeParams.catId,
          page: Number(this.routeParams.page) + 1,
        },
        query: this.routeQuery,
      });
    },

    handleLastPageClick() {
      return this.$router.push({
        name: 'catCard.results',
        params: { catId: this.routeParams.catId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../assets/styles/components/_typographies';
  @import '../../../assets/styles/components/_breakpoints';

  @mixin pages-button {
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    height: 40px;
    width: 108px;
    border-radius: 20px;
    cursor: pointer;
    border: none;
    font-size: 14px;
    color: rgba(0, 0, 0, 1);

    @media (min-width: $desktop-breakpoint) {
      width: 160px;
      height: 48px;
      font-size: 20px;
    }

    span {
      font-weight: bold;
    }

    img {
      width: 12px;
      height: 12px;
      margin: 0 0 2px 0;

      @media (min-width: $desktop-breakpoint) {
        width: 16px;
        height: 16px;
      }
    }

    &:disabled {
      box-shadow: none;
      color: #aaaaaa;
    }
  }

  .pages-pagination-container {
    background-color: #ffffff;
    padding: 18px 0 18px 0;
    text-align: center;
    z-index: 100;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    font-size: 14px;
    font-weight: 100;

    @media (min-width: $desktop-breakpoint) {
      font-size: 18px;
    }
  }

  .pages-pagination-wrapper {
    max-width: 570px;
    margin: 0 auto;
  }

  .pages-pagination--pager {
    color: #808080;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pages-pagination--pending {
    float: right;
    @include pages-button;

    span {
      margin-right: 14px;
      font-weight: 400;
    }
  }

  .pages-pagination--next {
    @include pages-button;
    float: right;
    text-decoration: none;
    color: #9013fe;

    span {
      margin-right: 6px;
    }
  }

  .pages-pagination--next:active {
    box-shadow: none;
  }

  .pages-pagination--next:focus {
    outline: none;
  }

  .pages-pagination--previous {
    float: left;
    text-decoration: none;
    @include pages-button;

    span {
      margin-left: 6px;
    }
  }

  .pages-pagination--previous:active {
    box-shadow: none;
  }

  .pages-pagination--previous:focus {
    outline: none;
  }

</style>
